import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.mermaid = bracketIndenting({
	line: "%%",
})
